import { ModalContext } from "@lib/context/ModalContext";
import { Show, useContext } from "solid-js";
import { PersonnelContactForm } from "./PersonnelContactForm";

function normalizeTimeAgo(days: number | undefined): string | undefined {
  if (days === undefined) return undefined;

  if (days > 365) {
    return `${(days / 365).toFixed(1)} year(s) ago`;
  } else if (days >= 31) {
    return `${(days / 30.5).toFixed(1)} month(s) ago`;
  } else {
    return `${days} day(s) ago`;
  }
}

export function ModalFooter() {
  const context = useContext(ModalContext)!;

  return (
    <div
      class="modal-footer d-block text-light border-secondary"
      style={{ "overflow-y": "scroll", "max-height": "40vh" }}
    >
      <div class="my-2">
        <div>
          <span class="fw-bold">Rep Name:</span>{" "}
          {document.querySelector("#repNameHolder")?.getAttribute("value") ?? "..."}
        </div>
        <div>
          <span class="fw-bold">SOID:</span> {context.soid() ?? "..."}
        </div>
        <div>
          <span class="fw-bold">Client:</span> {context.clientName() ?? "..."}
        </div>
        <div>
          <span class="fw-bold">Store:</span> {context.storeInfo()?.name ?? "..."}
        </div>
        <div
          classList={{
            // @ts-expect-error: undefined < number === false which is ok here
            "alert alert-warning": context.storeInfo()?.num_days_ago_first_seen < 14,
          }}
        >
          <span class="fw-bold">Store first seen:</span>{" "}
          {normalizeTimeAgo(context.storeInfo()?.num_days_ago_first_seen) ?? "..."}
        </div>
      </div>
      <Show when={context.isFillSuccessful()}>
        <PersonnelContactForm />
      </Show>
    </div>
  );
}
